import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preset", "custom", "input", "customLabel", "presetLabel"]

  toggle() {
    if (this.inputTarget.disabled) {
      this.#useCustom()
    } else {
      this.#usePresets()
    }
  }

  #useCustom() {
    this.previousPreset = this.presetTargets.find(preset => preset.checked)
    if (this.previousPreset) {
      this.inputTarget.value = this.previousPreset.value
      this.previousPreset.checked = false
    }

    this.#setMode(true)
    this.inputTarget.focus()
  }

  #usePresets() {
    const matching = this.presetTargets.find(preset => preset.value === this.inputTarget.value)
    const preset = matching || this.previousPreset
    if (preset) preset.checked = true

    this.#setMode(false)
  }

  #setMode(custom) {
    this.presetTargets.forEach(preset => preset.disabled = custom)
    this.inputTarget.disabled = !custom
    this.customTarget.classList.toggle("hidden", !custom)
    this.customLabelTarget.classList.toggle("hidden", custom)
    this.presetLabelTarget.classList.toggle("hidden", !custom)
  }
}
